import axios from "axios";

export default class TarifasService {
  crearTarifa(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "tarifas/create", data);
  }
  updateTarifa(data) {
    return axios.put(process.env.VUE_APP_API_PUBLIC + "tarifas/update",data);
  }  
  eliminarTarifa(data) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "tarifas/delete", {
      data: data,
    });
  }
  allTarifas() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "tarifas/todas");
  }
  allTarifasUsers() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "tarifas/for-users");
  }
  downloadCotizacion(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "tarifas/descargapdf", data,{
      responseType: "blob"
    });
  }
  //pruebas
  allTarifasUsersTest() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "tarifastest/for-users");
  }  
}
